// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> james-river-pointe
// Generated: 2026-10-22T20:06:26.605Z
// Counts: 1 design, 67 content, 52 slot group, 2 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Townhomes for Rent in Richmond , VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to James River Pointe, where spacious one, two, and three-bedroom townhomes harmonize with vibrant Richmond living. Nestled near cultural gems like the Virginia Museum of Fine Arts and the enchanting Lewis Ginter Botanical Garden, your new home invites you to embrace a life rich with arts, nature, and adventure!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Space, Your Home, Your Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At James River Pointe in Richmond, VA, comfort meets convenience. Choose from one, two, or three-bedroom townhomes featuring modern amenities like a pet-friendly environment, grilling stations, and a refreshing swimming pool. Our bilingual team is here to ensure your living experience is exceptional and worry-free. Your perfect home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Tour the community from anywhere</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At James River Pointe in Richmond, VA, vibrant living awaits you! Choose from stylish one, two, and three-bedroom floor plans, complete with pet-friendly amenities, a sparkling swimming pool, and a welcoming dog park. Join our community today and enjoy seamless online leasing—your perfect home is just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At James River Pointe in Richmond, VA, our diverse floor plans—one, two, and three-bedroom townhomes—cater to your unique lifestyle. Enjoy spacious living and modern amenities with stunning river views. Curious about available options? Reach out to our leasing team today and elevate your living experience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At James River Pointe in Richmond, VA, your ideal living space awaits! Choose from thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Embrace comfort and style while browsing our available townhomes to find the perfect fit for you. Your new adventure starts today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At James River Pointe in Richmond, VA, vibrant living comes alive through diverse floor plans—one, two, and three-bedroom options perfect for any lifestyle. Picture weekend BBQs at our grilling stations, fun at the playground, or lounging by the pool. Imagine your new home, where comfort meets convenience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to James River Pointe, where spacious one, two, and three-bedroom townhomes harmonize with vibrant Richmond living. Nestled near cultural gems like the Virginia Museum of Fine Arts and the enchanting Lewis Ginter Botanical Garden, your new home invites you to embrace a life rich with arts, nature, and adventure!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Richmond , VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per townhome, with each pet up to 100 lb. There is a one‑time, non‑refundable pet fee of $350 and monthly pet rent is $50.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>James River Pointe offers thoughtfully designed and pet-friendly one, two, and three bedroom townhomes near Bon Air in Richmond with the amenities and extras that make your life comfortable and easy. Enjoy an on-site playground and resort-style pool as well as a fully equipped kitchen and full-size stackable washer and dryers in select homes. Our charming community is conveniently located near popular dining, outdoor recreation, and shopping so your next-level living experience extends far beyond your front door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to James River Pointe in vibrant Richmond, VA, where comfort meets convenience. Our diverse floor plans—one, two, and three-bedroom options—cater to every lifestyle. Stay connected and make life easier by accessing your resident portal to pay rent, schedule maintenance, and explore community updates. Your new home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At James River Pointe in Richmond, VA, find your ideal space among our thoughtfully designed one, two, and three-bedroom floor plans. Each home boasts modern comfort and style. Curious about our vibrant community? Schedule a tour and see what our residents love most about living here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to James River Pointe! Nestled in the heart of Richmond, VA, our stylish one, two, and three-bedroom floor plans cater to your lifestyle. A team member will connect with you soon to help you find your perfect home in our vibrant community.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-acb7-733d-8dda-c16fac9f2cec.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright modern apartment living room with gray sofa, coffee table, and armchair at James River Pointe in Richmond, VA."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/01a15580-60a6-75be-ba0c-17a572265380.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fluffy Pomeranian dog sits adorably on a white couch with pillows."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-9287-766c-836c-97bd8d7cf18c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with dark brown cabinets, black appliances, and a gray countertop at James River Pointe Townhomes in Richmond, VA."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-acb7-733d-8dda-c16fac9f2cec.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright modern living room with gray sofa, coffee table, armchair, and wall art at James River Pointe Townhomes in Richmond, VA."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-b644-725b-82fa-6e60063aecc8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright bedroom with white bed, gray bench, and window with curtains at James River Pointe Townhomes in Richmond, VA."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-e316-76f8-a8d2-f1ca01146f1b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of red brick townhomes with front porches along a tree-lined walkway at James River Pointe in Richmond, VA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4a2f-711e-92ba-82a336af4911.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooded riverside trail at James River Park's Pony Pasture near James River Pointe in Richmond, VA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2a1e-77b8-b34e-003f9f1b389e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The historic Byrd Theatre movie palace, a Richmond, VA landmark near James River Pointe."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-3124-76ad-a5eb-9887e19c983f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gardens and grounds of the historic Maymont estate in Richmond, VA near James River Pointe."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c5e4-7328-949b-22af070d33f0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resort-style outdoor swimming pool with lounge chairs and umbrellas at James River Pointe in Richmond, VA."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-c8d7-70ac-b2a9-812fd866109d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs, umbrellas, and apartment buildings on a sunny day at James River Pointe Townhomes in Richmond, VA."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-d230-769a-9ece-c512c5babe7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Park picnic area with a grill, benches, trash cans, and trees under a blue sky at James River Pointe Townhomes in Richmond, VA."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fcdff-d662-749c-8155-e17e6eebbb46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Grassy dog park between red brick houses, with small agility obstacles and black fencing at James River Pointe Townhomes in Richmond, VA."
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$1000*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce6b-2ec6-74f9-8263-9e37b981cbcd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019d0267-04ff-778b-a66f-2c10158ddf37.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Compact apartment kitchen with a round dining table for two by a window and a black refrigerator."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce6b-2eb4-7410-be2d-7a252acc80dc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce6b-2f26-77cf-9706-299abf2004c7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce6b-2f55-7087-9a44-75c1564c4c09.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-019c-754a-8e03-281bb34d5f7f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Crossroads Coffee & Ice Cream"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Coffee"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Funky breakfast-through-dinner cafe serving simple American fare, desserts & craft beer."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1da7-75cb-bab8-853a571f305d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Publix Super Market at Carytown Exchange"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4a2f-711e-92ba-82a336af4911.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "James River Park Pony Pasture"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Outdoors"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Riverside park featuring scenic trails for biking and hiking, as well as swimming."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0159-766d-bbdc-50045399a043.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Eat 66"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast place featuring catfish, chicken and waffles, pancakes and other Southern eats in a vibrant setting."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2ebd-72b9-bb58-6f38d1463b67.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Virginia Museum of Fine Arts"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Museum with a varied, sizable collection of modern art, antiquities & Asian art, plus Fabergé eggs."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-4b9d-7532-b429-0c9ad648c99b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Reedy Creek Trailhead"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Trails & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Parking lot & staging area for a scenic nature hike along a channel of the James River."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0941-7559-b4b6-c11289e3f0f3.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "O'Toole's Restaurant & Pub"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Pub"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Long-running Irish joint with brick walls & sports on TV provides bar food & pints."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-38ad-70fc-8e68-e77090660c51.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Broadberry"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Modest concert venue hosting local & touring acts, plus a small pub grub menu & full bar."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-08d2-71fd-a1e9-5381fdf40bd3.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Maldini's Ristorante Pizzeria"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Italian Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Warm, familiar Italian bar & restaurant preparing brick-oven pizzas, sandwiches & classic mains."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-1021-72c9-bc89-233f7450c38b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Little Nickel"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cocktails & Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Stylish diner-style stop serving Philippine, Hawaiian, & Mediterranean fusion plus tropical drinks."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-2a1e-77b8-b34e-003f9f1b389e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Byrd Theatre"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "An historic landmark, this opulent 1928 movie palace now shows second-run films in grand style."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166324/019fce00-0805-70cb-9307-783097880de0.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "DaVinci Pizza"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual eatery offering pizza, wings, and other comfort food, plus late-night hours."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 43,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 46,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 39,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 26,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_78598fc7-0640-4d05-bc5a-12ca967a0415",
      "custom_6b126d02-3b2b-4859-9459-66091027415c",
      "custom_ba9401bd-a1bd-4085-8363-e34707fe72ac",
      "custom_d2c7435f-227b-43fa-a50f-d998bcc07579",
      "custom_40a6c09d-77d4-4a0a-8472-57b48237ca88",
      "custom_a13b5237-266b-4951-ba92-9b2005f0e812",
      "custom_396a7e7a-327f-4991-a1fd-6e0d6ec96fc7",
      "custom_903ae4a6-1d9f-4534-a186-ecbc0b3e3e20",
      "custom_1b537e4f-b9f8-4b7f-b55a-43ae4544b2df",
      "custom_b4d75ee3-041f-4ae4-b8c6-6b4d70e9bc2d",
      "custom_66051383-f324-4b2b-8629-7d18d6121210",
      "custom_0a95d5b6-6512-431c-94a4-a30c75248c9b",
      "custom_5da7962d-22be-430e-b50d-d87681bc4e3c",
      "custom_33ceb6b0-24b4-4923-98be-39f807680a38",
      "custom_22f0e0ad-02fe-4423-9385-392501a9e69c",
      "custom_49735b1e-9a89-49e3-abc4-b7ff57c766dd",
      "custom_76d1ee43-b922-42ca-b2ae-042aee37f2c5",
      "custom_4b0cbb3d-9a43-4a21-bce8-a456dbb94416",
      "custom_e96aa1be-30a2-468c-b29d-a59b35e3ecc3",
      "custom_fb935e55-2628-4c1a-91b8-9ee738099d89",
      "custom_1e347fae-97b9-45ff-b5ad-9b160537f839",
      "custom_ae1300ef-5ec1-43c0-b9c5-182a090136e3",
      "custom_43c475d2-0b64-4fc2-b076-39105405b9dd",
      "custom_c20ba94c-caba-4f9c-8bf3-11b31ac5bab5",
      "custom_d7a5c65c-3238-4ed6-bcb1-d4a62f1f6694",
      "custom_df993415-e114-48ab-b5b8-ff4ca02a2bf7",
      "custom_caf99f62-6700-45bb-aeb1-3c2bb10b8f8c",
      "custom_d1539204-e8f7-48e4-bca0-867d7bbe8b7c",
      "custom_dd8779cd-5658-4f2b-b864-ebfb097e85da",
      "custom_16307254-0ada-4081-bca0-febf62e0d36c",
      "custom_1e3c5059-25eb-4ab0-960f-3ce4fb728af7",
      "custom_08e9e72d-de8e-4494-a5e1-a9ed0ad391cd"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "custom_76d1ee43-b922-42ca-b2ae-042aee37f2c5",
      "custom_4f2fe06f-6623-4ed2-8441-d9ec8cf86530",
      "custom_effbaaca-5a94-44f9-82c4-6cca9ea5023e",
      "custom_54eebf4d-2b73-4903-90e9-0f50aa2d830e",
      "custom_034ef96f-3b4c-468f-ac6f-4b34e591e41c",
      "custom_903ae4a6-1d9f-4534-a186-ecbc0b3e3e20",
      "custom_4b0cbb3d-9a43-4a21-bce8-a456dbb94416",
      "custom_e96aa1be-30a2-468c-b29d-a59b35e3ecc3",
      "custom_1b537e4f-b9f8-4b7f-b55a-43ae4544b2df",
      "custom_5da7962d-22be-430e-b50d-d87681bc4e3c",
      "custom_22f0e0ad-02fe-4423-9385-392501a9e69c",
      "custom_fb935e55-2628-4c1a-91b8-9ee738099d89",
      "custom_93643f2a-e3f3-41d8-a8fe-a275a6cbc4a0",
      "custom_494125ec-4f63-44f1-95b2-3d36a296f770",
      "custom_0a95d5b6-6512-431c-94a4-a30c75248c9b",
      "custom_692dfef7-3fcf-4fc4-b256-a1f0cc3951ca",
      "custom_8779d0b8-7085-4e23-a48e-56a6ea62b3a3",
      "custom_8496a570-0730-4b18-a116-f2f4ce3d9a9f"
    ],
    "orderedIds": [
      "custom_78598fc7-0640-4d05-bc5a-12ca967a0415",
      "custom_1e347fae-97b9-45ff-b5ad-9b160537f839",
      "custom_43c475d2-0b64-4fc2-b076-39105405b9dd",
      "custom_ae1300ef-5ec1-43c0-b9c5-182a090136e3",
      "custom_d2c7435f-227b-43fa-a50f-d998bcc07579",
      "custom_66051383-f324-4b2b-8629-7d18d6121210",
      "custom_a13b5237-266b-4951-ba92-9b2005f0e812",
      "custom_396a7e7a-327f-4991-a1fd-6e0d6ec96fc7",
      "custom_d7a5c65c-3238-4ed6-bcb1-d4a62f1f6694",
      "custom_d1539204-e8f7-48e4-bca0-867d7bbe8b7c",
      "custom_6b126d02-3b2b-4859-9459-66091027415c",
      "custom_40a6c09d-77d4-4a0a-8472-57b48237ca88",
      "custom_1e3c5059-25eb-4ab0-960f-3ce4fb728af7",
      "custom_33ceb6b0-24b4-4923-98be-39f807680a38",
      "custom_49735b1e-9a89-49e3-abc4-b7ff57c766dd",
      "custom_ba9401bd-a1bd-4085-8363-e34707fe72ac",
      "custom_b4d75ee3-041f-4ae4-b8c6-6b4d70e9bc2d",
      "custom_c20ba94c-caba-4f9c-8bf3-11b31ac5bab5",
      "custom_df993415-e114-48ab-b5b8-ff4ca02a2bf7",
      "custom_16307254-0ada-4081-bca0-febf62e0d36c",
      "custom_dd8779cd-5658-4f2b-b864-ebfb097e85da",
      "custom_caf99f62-6700-45bb-aeb1-3c2bb10b8f8c",
      "custom_08e9e72d-de8e-4494-a5e1-a9ed0ad391cd",
      "custom_903ae4a6-1d9f-4534-a186-ecbc0b3e3e20",
      "custom_1b537e4f-b9f8-4b7f-b55a-43ae4544b2df",
      "custom_0a95d5b6-6512-431c-94a4-a30c75248c9b",
      "custom_5da7962d-22be-430e-b50d-d87681bc4e3c",
      "custom_22f0e0ad-02fe-4423-9385-392501a9e69c",
      "custom_76d1ee43-b922-42ca-b2ae-042aee37f2c5",
      "custom_4b0cbb3d-9a43-4a21-bce8-a456dbb94416",
      "custom_e96aa1be-30a2-468c-b29d-a59b35e3ecc3",
      "custom_fb935e55-2628-4c1a-91b8-9ee738099d89",
      "custom_034ef96f-3b4c-468f-ac6f-4b34e591e41c",
      "custom_54eebf4d-2b73-4903-90e9-0f50aa2d830e",
      "custom_48066c8f-ca3a-42db-be84-c10ea92b0b8a",
      "custom_4ad4da34-e3e4-49e5-985f-69a886938e3c",
      "custom_93643f2a-e3f3-41d8-a8fe-a275a6cbc4a0",
      "custom_ddc55432-4a7e-4732-bc63-47edbc2628aa",
      "custom_494125ec-4f63-44f1-95b2-3d36a296f770",
      "custom_2eda2e1b-17b1-4045-964e-c6a474875cc5",
      "custom_82a5bfb9-773f-44aa-a733-ee4ddc08ff6d",
      "custom_99a1bfab-b860-4020-88a6-b56ede696e85",
      "custom_dca95493-e4bc-4bcd-908e-88ed58c1e6c0",
      "custom_effbaaca-5a94-44f9-82c4-6cca9ea5023e",
      "custom_2a6f2ea1-7551-431e-b827-c1fff89be184",
      "custom_692dfef7-3fcf-4fc4-b256-a1f0cc3951ca",
      "custom_7c3a661d-e963-458c-a224-3a6e0ca02e0f",
      "custom_8496a570-0730-4b18-a116-f2f4ce3d9a9f",
      "custom_360e0218-7179-4734-8adb-c3d695d37da0",
      "custom_8779d0b8-7085-4e23-a48e-56a6ea62b3a3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
